import { httpInterceptor } from '../http-interceptor';

export class DashboardService {
  static ENDPOINTS = {
    GET_DASHBOARD_DATA: 'Mobile/dashboarddata',
    COMPLETE_PROCESS: 'Mobile/completeprocess',
  };

  static async getDashboardData() {
    console.log('Calling dashboard API endpoint:', this.ENDPOINTS.GET_DASHBOARD_DATA);
    try {
      const response = await httpInterceptor.get(this.ENDPOINTS.GET_DASHBOARD_DATA);
      console.log('Dashboard API response received:', response);
      return response;
    } catch (error) {
      console.error('Dashboard API call failed:', error);
      throw error;
    }
  }

  static async completeProcess(workTicketNumber) {
    const encodedWorkTicketNumber = encodeURIComponent(workTicketNumber);
    return httpInterceptor.post(`${this.ENDPOINTS.COMPLETE_PROCESS}/${encodedWorkTicketNumber}`, null);
  }
} 